// Slider/draggable logic for rc-content-text__list

const initRcContentTextSlider = (sliderComponent) => {
  const slider = sliderComponent.querySelector('.rc-content-text__list');
  if (!slider) return;

  if (sliderComponent.dataset.rcContentTextInitialized === 'true') return;
  sliderComponent.dataset.rcContentTextInitialized = 'true';

  // Drag-to-scroll
  let isDragging = false;
  let didDrag = false;
  let startX = 0;
  let scrollLeft = 0;

  slider.addEventListener('mousedown', (e) => {
    isDragging = true;
    didDrag = false;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('dragging');
  });

  slider.addEventListener('mouseleave', () => {
    isDragging = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDragging = false;
    slider.classList.remove('dragging');

    setTimeout(() => {
      didDrag = false;
    }, 0);
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 5) {
      didDrag = true;
    }

    slider.scrollLeft = scrollLeft - walk;
  });

  slider.addEventListener('click', function (e) {
    const link = e.target.closest('.rc-content-text__link');
    if (!link || !link.getAttribute('href')) return;

    if (didDrag) {
      e.preventDefault();
    }
  });
};

const initRcContentTextSliders = () => {
  document.querySelectorAll('.rc-content-text-slider').forEach((sliderComponent) => {
    initRcContentTextSlider(sliderComponent);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRcContentTextSliders);
} else {
  initRcContentTextSliders();
}

document.addEventListener('rcContentText:reload', function () {
  initRcContentTextSliders();
});
